import { Icon } from '@eventbrite/eds-icon';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import { Fire } from './icons/Fire';
import { Megaphone } from './icons/Megaphone';
import { useUrgencyMessages } from './provider';
import { UrgencyMessageType } from './types';
import './UrgencyMessages.scss';

export type UrgencyMesssagesProps = {
    type: UrgencyMessagesTypes;
    className?: string;
};

export enum UrgencyMessagesTypes {
    hurry = 'hurry',
    info = 'info',
}

export const UrgencyMessage: React.FC<UrgencyMesssagesProps> = ({
    children,
    type,
    className,
}) => {
    return (
        <div
            className={classNames(
                `urgency-message urgency-message--${type}`,
                className,
            )}
        >
            {children}
        </div>
    );
};

export const UrgencyMessageHurry: React.FC<{ className?: string }> = ({
    children,
    className,
}) => (
    <UrgencyMessage type={UrgencyMessagesTypes.hurry} className={className}>
        <Icon type={<Fire />} size="xsmall" />
        {children}
    </UrgencyMessage>
);

export const FewTicketsLeft = ({ className }: { className?: string }) => (
    <UrgencyMessageHurry className={className}>
        {gettext('Few tickets left')}
    </UrgencyMessageHurry>
);

export const GoingFast = ({ className }: { className?: string }) => (
    <UrgencyMessageHurry className={className}>
        {gettext('Going fast')}
    </UrgencyMessageHurry>
);

export const TicketSalesEndSoon = ({ className }: { className?: string }) => (
    <UrgencyMessage type={UrgencyMessagesTypes.info} className={className}>
        <Icon type={<Megaphone />} size="small" />
        {gettext('Ticket sales end soon')}
    </UrgencyMessage>
);

export const UrgencyMessages: React.FC<{ className?: string }> = ({
    className,
}) => {
    const values = useUrgencyMessages();

    return (
        <>
            {values[UrgencyMessageType.GoingFast] && (
                <GoingFast className={className} />
            )}
            {values[UrgencyMessageType.FewTickets] && (
                <FewTicketsLeft className={className} />
            )}
            {values[UrgencyMessageType.SalesEndSoon] && (
                <TicketSalesEndSoon className={className} />
            )}
        </>
    );
};
